<template>
  <div class="common" :class="map[status].class">
    <img v-if="map[status].icon != ''" :src="map[status].icon"/>
    <span>{{map[status].text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    status
  },
  data() {
    return {
      map: {
        "1": {
          text: "直播预告",
          icon: "",
          class: "beforestare"
        },
        "2": {
          text: "直播中",
          icon: require('../assets/images/live-icon.png'),
          class: "start"
        },
        "3": {
          text: "直播结束",
          icon: "",
          class: "end"
        },
        "4": {
          text: "回放中",
          icon: require('../assets/images/icon-backl.png'),
          class: "playback"
        }
      }
    };
  }
};
</script>

<style scoped>
.common {
  width: 1.1rem;
  height: 0.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.05rem;
}
.common>span {
  font-size: .22rem;
  color: #fff;
}
.start>img {
  width: .16rem;
  height: .17rem;
  margin-right: .1rem;
}
.playback>img {
  width: .22rem;
  height: .22rem;
  margin-right: .1rem;
}
.beforestare {
  background: rgba(66, 146, 255, 1);
}
.start {
  background: rgba(215, 19, 26, 1);
}
.end {
  background: rgba(158, 157, 157, 1);
}
.playback {
  background: rgba(0, 153, 68, 1);
}
</style>
